;(function () {
  angular
    .module('contrast.protect.rules')
    .controller('ProtectionRuleCtrl', ProtectionRuleCtrl)

  function ProtectionRuleCtrl(
    $scope,
    $timeout,
    $translate,
    ChartService,
    PromiseService,
    ErrorService,
    FeaturesService,
    UserService,
    ProtectionRulesFactory,
    AGENT_FEATURE,
    PROTECT_RULES_EXPAND_BREAKDOWN_PROPERTIES
  ) {
    'ngInject'

    var translGlobal = {
      title_all_applications: $translate.instant('title_all_applications')
    }

    var _searchKeywords = ''

    angular.extend($scope, {
      rules: [],
      model: {
        searchKeywords: searchKeywords,
        busy: true,
        row: 'name',
        totalDev: true,
        totalQa: true,
        totalProd: true
      },
      loadPromise: undefined,
      quickFilters: [],
      selectedQuickFilter: {
        name: translGlobal.title_all_applications,
        filterType: 'ALL',
        count: '?'
      },
      expandProperties: PROTECT_RULES_EXPAND_BREAKDOWN_PROPERTIES
    })

    angular.extend($scope, {
      order: order,
      quickFilterSelect: quickFilterSelect,
      hasMultipleRules: hasMultipleRules,
      getRulesByParentId: getRulesByParentId,
      getParentRuleName: getParentRuleName,
      getSemanticRuleNamePrefix: getSemanticRuleNamePrefix,
      getSemanticRuleNameSuffix: getSemanticRuleNameSuffix
    })

    function init() {
      if (UserService.isFreemiumOrganization()) {
        $scope.selectedQuickFilter = {
          name: 'JAVA',
          filterType: 'JAVA',
          count: '?'
        }
      }

      loadRules()
      getQuickFilters()
    }

    function getUniqueParentIds(rules) {
      return rules
        .map(function (rule) {
          return rule.parentRuleUuid
        })
        .filter(function (id, index, arr) {
          return arr.indexOf(id) == index
        })
    }

    function getParentRuleName(parentId) {
      var ruleFound = $scope.rules.find(function (rule) {
        return rule.parentRuleUuid === parentId
      })
      return ruleFound ? ruleFound.parentRuleName : ''
    }

    function getRulesByParentId(parentId) {
      return $scope.rules.filter(function (rule) {
        return rule.parentRuleUuid === parentId
      })
    }

    function getSemanticRuleNamePrefix(semanticRuleName) {
      return semanticRuleName.split('-')[1]
    }

    function getSemanticRuleNameSuffix(semanticRuleName) {
      return semanticRuleName.split('-')[0]
    }

    function hasMultipleRules(parentId) {
      return getRulesByParentId(parentId).length > 1
    }

    function loadRules() {
      if ($scope.loadPromise) {
        PromiseService.cancelPromise($scope.loadPromise)
      }

      var searchKeywords = $scope.model.searchKeywords()
      var selectedQuickFilter = $scope.selectedQuickFilter
      var params = {
        quickFilter: selectedQuickFilter.filterType,
        q: searchKeywords,
        sort: $scope.model.row,
        expand: $scope.expandProperties
      }

      $scope.loadPromise = ProtectionRulesFactory.getOnlyProtectionRules(params)
        .then(function (response) {
          var rules = response.data.rules

          if (rules[0]) {
            var i, rule
            for (i = 0; i < rules.length; i++) {
              rule = rules[i]

              rule.parentRuleUuid = rule.parent_rule_uuid
              rule.parentRuleName = rule.parent_rule_name

              rule.totalDev =
                rule.development.total_blocking_perimeter_apps +
                rule.development.total_blocking_apps +
                rule.development.total_monitoring_apps +
                rule.development.total_monitor_perimeter_apps +
                rule.development.total_off_apps
              rule.totalQa =
                rule.qa.total_blocking_perimeter_apps +
                rule.qa.total_blocking_apps +
                rule.qa.total_monitoring_apps +
                rule.qa.total_monitor_perimeter_apps +
                rule.qa.total_off_apps
              rule.totalProd =
                rule.production.total_blocking_perimeter_apps +
                rule.production.total_blocking_apps +
                rule.production.total_monitoring_apps +
                rule.production.total_monitor_perimeter_apps +
                rule.production.total_off_apps

              rule.development.data = ChartService.buildProtectionModeData(
                rule.development,
                rule.totalDev
              )
              rule.qa.data = ChartService.buildProtectionModeData(
                rule.qa,
                rule.totalQa
              )
              rule.production.data = ChartService.buildProtectionModeData(
                rule.production,
                rule.totalProd
              )

              if (rule.totalDev > 0) {
                $scope.model.totalDev = false
              }
              if (rule.totalQa > 0) {
                $scope.model.totalQa = false
              }
              if (rule.totalProd > 0) {
                $scope.model.totalProd = false
              }

              rule.isInAllLanguages = FeaturesService.isFeatureInAllLanguages(
                AGENT_FEATURE.PROTECTION,
                rule.languages
              )
            }
          }

          $scope.ruleParentIds = getUniqueParentIds(rules)

          $scope.rules = sortRules(
            rules,
            $scope.model.row === 'name' ? 'ASC' : 'DESC'
          )

          $scope.model.busy = false
          $timeout(function () {
            $scope.$emit('triggerScrollCheck')
          })
        })
        .catch(function (response) {
          $scope.model.busy = false
          ErrorService.processError(response)
        })
    }

    function getQuickFilters() {
      var data = {
        q: $scope.model.searchKeywords()
      }

      $scope.quickFiltersPromise =
        ProtectionRulesFactory.getProtectionRulesQuickFilters(data)
          .then(function (response) {
            $scope.quickFilters = response.data.filters
            $scope.selectedQuickFilter = $scope.quickFilters.find(function (
              filter
            ) {
              return filter.filterType === $scope.selectedQuickFilter.filterType
            })
          })
          .catch(ErrorService.processError)

      return $scope.quickFiltersPromise
    }

    function quickFilterSelect(filter) {
      $scope.selectedQuickFilter = filter
      applyFilters()
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }
      $scope.model.busy = true
      applyFilters()

      return _searchKeywords
    }

    function order(rowName) {
      if ($scope.model.row === rowName) {
        return
      }

      $scope.model.row = rowName
      $scope.model.busy = true
      applyFilters()
    }

    function applyFilters(reloadQuickFilters) {
      loadRules()
      if (angular.isUndefined(reloadQuickFilters) || reloadQuickFilters) {
        PromiseService.cancelPromise($scope.quickFiltersPromise)
        getQuickFilters()
      }
    }

    function getRuleNameOrChildRuleName(ruleName) {
      const ruleSplit = ruleName.split('-').map((rule) => rule.trim())
      return ruleSplit.length === 1 ? ruleSplit[0] : ruleSplit[1]
    }

    function sortRules(rules, orderType) {
      return rules.slice().sort((a, b) => {
        const aName = getRuleNameOrChildRuleName(a.name)
        const bName = getRuleNameOrChildRuleName(b.name)

        return orderType === 'ASC'
          ? aName.localeCompare(bName)
          : bName.localeCompare(aName)
      })
    }

    init()
  }
})()
